export default __webpack_public_path__ + "static/media/Scandic_10_x_15.89fa4c91.jpg";